import { Component, signal, OnInit, Inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CommonModule, DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { ContentService } from './services/content.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('The Husk Bakery');
  isAdminRoute = false;
  isMaintenanceRoute = false;

  constructor(
    private router: Router, 
    private contentService: ContentService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.isAdminRoute = event.urlAfterRedirects.includes('/admin');
      this.isMaintenanceRoute = event.urlAfterRedirects.includes('/maintenance');
    });
    
    this.isAdminRoute = this.router.url.includes('/admin');
    this.isMaintenanceRoute = this.router.url.includes('/maintenance');

    this.contentService.getHomeContent().subscribe({
      next: (data: any) => {
        if (data && data.logoImage) {
          const url = data.logoImage.startsWith('http') ? data.logoImage : 'https://dev.thehuskbakery.com/' + data.logoImage;
          let link: HTMLLinkElement | null = this.document.querySelector("link[rel~='icon']");
          if (!link) {
            link = this.document.createElement('link');
            link.rel = 'icon';
            this.document.head.appendChild(link);
          }
          link.href = url;
        }
      }
    });
  }
}
